import Decimal from 'decimal.js';

export class ProcessMicroPaymentDto {
    readonly first_name: string;

    readonly last_name: string;

    readonly email: string;

    readonly room_code: string;

    readonly academic_year: string;

    readonly vita_ref: string;

    readonly amount: Decimal | null;

    readonly sf_payment_id: string | null;

    constructor(
        firstName: string,
        lastName: string,
        email: string,
        roomCode: string,
        academicYear: string,
        vitaRef: string,
        amount?: Decimal,
        pid?: string
    ) {
        this.first_name = firstName;
        this.last_name = lastName;
        this.email = email;
        this.room_code = roomCode;
        this.academic_year = academicYear;
        this.vita_ref = vitaRef;
        this.amount = amount || null;
        this.sf_payment_id = pid || null;
    }

    public serialisePayment() {
        return {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            room_code: this.room_code,
            academic_year: this.academic_year,
            vita_ref: this.vita_ref,
            amount: this.amount ? this.amount.toFixed(2) : null,
            sf_payment_id: this.sf_payment_id,
        };
    }
}
